import Input from "components/input";
import { Label } from "components/label";
import { IAttractionBuildEventPageForm, SupportedLanguage } from "interfaces";
import { get } from "lodash";
import { useFormContext } from "react-hook-form";

export const MultilingualContent = ({ isEdit, id }: { isEdit: boolean, id: string | null }) => {

  const {
    register,
    getFieldState,
    getValues,
    formState: { errors },
  } = useFormContext<IAttractionBuildEventPageForm>(); // retrieve all hook methods

  return (
    <div className="box-container">
      {!isEdit ? (
        (!getFieldState("multilingual_content").isTouched ||
        errors["multilingual_content"]) && !id ? (
          <p>
            Use this section to set up the language content for the information
            fields displayed on the ActiUp website.
          </p>
        ) : (
          <div className="flex flex-col gap-y-4 text-sm">
            <div className="flex flex-col sm:flex-row gap-2">
              <p className="shrink-0 w-48 font-bold">Event name:</p>
              <div className="flex flex-col gap-y-3">
                {getValues("languages").map((language, index) => (
                  <p key={index}>
                    <img
                      src={`/images/flags/circle-${language}.png`}
                      alt="Flag icon"
                      className="inline mr-2.5"
                    />
                    {getValues("multilingual_content").name[language]}
                  </p>
                ))}
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-2">
              <p className="shrink-0 w-48 font-bold">Event place:</p>
              <div className="flex flex-col gap-y-3">
                {getValues("languages").map((language, index) => (
                  <p key={index}>
                    <img
                      src={`/images/flags/circle-${language}.png`}
                      alt="Flag icon"
                      className="inline mr-2.5"
                    />
                    {getValues("multilingual_content").place[language]}
                  </p>
                ))}
              </div>
            </div>
            {id ? (
              <div className="flex flex-col sm:flex-row gap-2">
                <p className="shrink-0 w-48 font-bold">Display Organization name:</p>
                <div className="flex flex-col gap-y-3">
                  {getValues("languages").map((language, index) => (
                    <p key={index}>
                      <img
                        src={`/images/flags/circle-${language}.png`}
                        alt="Flag icon"
                        className="inline mr-2.5"
                      />
                      {getValues("multilingual_content").merchant_name[language]}
                    </p>
                  ))}
                </div>
              </div>
            ) : <></>}
          </div>
        )
      ) : (
        <div className="grid gap-x-4 gap-y-6 sm:grid-cols-6 lg:gap-x-6">
          <div className="col-span-full">
            <Label required id="event_name_en" name="Event Name" />
            <div className="flex flex-col gap-y-4">
              {getValues("languages").map(
                (lang: SupportedLanguage, index: number) => (
                  <div key={lang}>
                    <div className="relative">
                      <Input
                        id={`event_name_${lang}`}
                        type="text"
                        placeholder="Event name"
                        className="pr-11"
                        error={get(
                          errors,
                          `multilingual_content.name.${lang}`,
                          ""
                        )}
                        {...register(`multilingual_content.name.${lang}`)}
                      />
                      <img
                        src={`/images/flags/circle-${lang}.png`}
                        alt="Language Icon"
                        className="absolute top-1/2 right-3 -translate-y-1/2"
                      />
                    </div>
                    {get(errors, `multilingual_content.name.${lang}`, "") ? (
                      <p className="error-text">
                        <span className="font-medium">
                          {get(
                            errors,
                            `multilingual_content.name.${lang}.message`,
                            ""
                          )}
                        </span>
                      </p>
                    ) : null}
                  </div>
                )
              )}
            </div>
          </div>

          <div className="col-span-full">
            <Label required id="event_place_en" name="Event Place" />
            <div className="flex flex-col gap-y-4">
              {getValues("languages").map(
                (lang: SupportedLanguage, index: number) => (
                  <div key={index}>
                    <div className="relative">
                      <Input
                        id={`event_place_${lang}`}
                        type="text"
                        placeholder="Event place"
                        className="pr-11"
                        error={get(
                          errors,
                          `multilingual_content.place.${lang}`,
                          ""
                        )}
                        {...register(`multilingual_content.place.${lang}`)}
                      />
                      <img
                        src={`/images/flags/circle-${lang}.png`}
                        alt="Language Icon"
                        className="absolute top-1/2 right-3 -translate-y-1/2"
                      />
                    </div>
                    {get(errors, `multilingual_content.place.${lang}`, "") ? (
                      <p className="error-text">
                        <span className="font-medium">
                          {get(
                            errors,
                            `multilingual_content.place.${lang}.message`,
                            ""
                          )}
                        </span>
                      </p>
                    ) : null}
                  </div>
                )
              )}
            </div>
          </div>
          {id ? (
            <div className="col-span-full">
              <Label id="merchant_name_en" name="Display Organization name" />
              <div className="flex flex-col gap-y-4">
                {getValues("languages").map(
                  (lang: SupportedLanguage, index: number) => (
                    <div key={index}>
                      <div className="relative">
                        <Input
                          id={`merchant_name_${lang}`}
                          type="text"
                          placeholder="Display Organization name"
                          className="pr-11"
                          error={get(
                            errors,
                            `multilingual_content.merchant_name.${lang}`,
                            ""
                          )}
                          {...register(`multilingual_content.merchant_name.${lang}`)}
                        />
                        <img
                          src={`/images/flags/circle-${lang}.png`}
                          alt="Language Icon"
                          className="absolute top-1/2 right-3 -translate-y-1/2"
                        />
                      </div>
                      {get(errors, `multilingual_content.merchant_name.${lang}`, "") ? (
                        <p className="error-text">
                          <span className="font-medium">
                            {get(
                              errors,
                              `multilingual_content.merchant_name.${lang}.message`,
                              ""
                            )}
                          </span>
                        </p>
                      ) : null}
                    </div>
                  )
                )}
              </div>
            </div>
          ) : <></>}
        </div>
      )}
    </div>
  );
};
